export enum Partner {
  finizens = 'Finizens',
  evo = 'EVO Banco',
  caser = 'Caser'
}

